var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag",class:{ 'is-success': _vm.status === 'open', 'is-dark': _vm.status === 'closed' }},[_vm._v("\n  "+_vm._s(_vm.$t("support_ticket.status." + _vm.status))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }